<div class="topic-filter">
  <div class="container-multiselect">
    <ng-select
      [items]="dropdownList"
      bindLabel="name"
      bindValue="id"
      (ngModelChange)="onSelectionChanged($event)"
      [multiple]="true"
      [(ngModel)]="selectedSessions"
      [virtualScroll]="true"
      [placeholder]="placeHolderString"
      [notFoundText]="'Topics not found'">
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label">{{ item.name }}</span>
        <span
          class="ng-value-icon right"
          (click)="clearTopic(item.id)"
          aria-hidden="true">
          ×
        </span>
      </ng-template>
    </ng-select>
  </div>
  <div class="topic-list" #divParent>
    <ul>
      <virtual-scroller
        [ngStyle]="{ height: height }"
        #scroll
        [items]="getSortedSessions()">
        <li *ngFor="let session of scroll.viewPortItems">
          <div
            class="topic-item"
            [class.unselectable]="!isFilteredSession(session)"
            [class.selected]="isSelected(session)"
            (click)="toggleTopic(session)">
            <div class="preview-image-container">
              <img
                alt
                class="preview-image"
                [src]="
                  session.config.thumbnail_id ||
                    'image/default_session_thumbnail.png' | assets
                " />
            </div>
            <div class="topic-details-container">
              <span class="topic-title">{{ session.config.title }}</span>

              <div class="topic-ideas-counter">
                <a href="/topics/{{ session._id }}" target="_blank">
                  show more
                </a>
              </div>
            </div>
          </div>
        </li>
      </virtual-scroller>
    </ul>
  </div>
</div>
